module.exports = __webpack_public_path__ + "img/OUT.ad0f3e3e.png";